(function () {
  var supportedLocales = ['fr', 'en', 'tr'];

  function currentLocale() {
    var locale = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    return supportedLocales.indexOf(locale) !== -1 ? locale : null;
  }

  function localePrefix(locale) {
    return locale === 'fr' ? '' : '/' + locale;
  }

  function localizedPath(pathname, prefix) {
    var unprefixedPath = pathname.replace(/^\/(?:en|tr)(?=\/|$)/, '') || '/';
    return prefix + (unprefixedPath.charAt(0) === '/' ? unprefixedPath : '/' + unprefixedPath);
  }

  function normalizeInternalUrl(rawUrl, prefix) {
    if (!rawUrl || rawUrl.charAt(0) === '#' || /^(?:mailto:|tel:|javascript:)/i.test(rawUrl)) return rawUrl;

    var url;
    try {
      url = new URL(rawUrl, window.location.origin);
    } catch (error) {
      return rawUrl;
    }

    if (url.origin !== window.location.origin) return rawUrl;
    if (/^\/(?:admin|checkouts|cdn|\.well-known)(?:\/|$)/.test(url.pathname)) return rawUrl;

    url.pathname = localizedPath(url.pathname, prefix);
    return url.pathname + url.search + url.hash;
  }

  function applyFormActions(prefix) {
    document.querySelectorAll('form.minisearch, form[action*="/search"]').forEach(function (form) {
      form.setAttribute('action', prefix + '/search');
    });

    document.querySelectorAll('form.language-form, form.currency-form').forEach(function (form) {
      form.setAttribute('action', prefix + '/localization');
    });

    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      var act = form.getAttribute('action') || '';
      if (!/^\/(?:admin|checkouts|cdn)(?:\/|$)/.test(act)) {
        form.setAttribute('action', normalizeInternalUrl(act, prefix));
      }
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.setAttribute('action', prefix + '/cart/add');
    });
  }

  function applyLocaleContext() {
    var locale = currentLocale();
    if (!locale) return;

    var prefix = localePrefix(locale);

    applyFormActions(prefix);

    var expectedRoot = prefix + '/';
    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var themeRoot = window.routes && window.routes.root_url;
    var mismatch = shopifyRoot !== expectedRoot || themeRoot !== (prefix || '/');

    if (window.Shopify && window.Shopify.routes) window.Shopify.routes.root = expectedRoot;

    if (window.routes) {
      window.routes.root_url = prefix || '/';
      window.routes.cart_url = prefix + '/cart';
      window.routes.cart_add_url = prefix + '/cart/add';
      window.routes.cart_change_url = prefix + '/cart/change';
      window.routes.cart_update_url = prefix + '/cart/update';
      window.routes.search_url = prefix + '/search';
    }

    document.querySelectorAll('a[href]').forEach(function (link) {
      var normalizedHref = normalizeInternalUrl(link.getAttribute('href'), prefix);
      if (normalizedHref !== link.getAttribute('href')) link.setAttribute('href', normalizedHref);
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') return;

    var locale = currentLocale();
    if (!locale) return;
    var prefix = localePrefix(locale);

    if (form.classList.contains('minisearch') || (form.getAttribute('action') && form.getAttribute('action').indexOf('/search') !== -1)) {
      form.action = prefix + '/search';
      form.setAttribute('action', prefix + '/search');
    } else if (form.classList.contains('language-form') || form.classList.contains('currency-form')) {
      form.action = prefix + '/localization';
      form.setAttribute('action', prefix + '/localization');
    } else if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      form.action = prefix + '/cart/add';
      form.setAttribute('action', prefix + '/cart/add');
    } else if (form.getAttribute('action') && form.getAttribute('action').indexOf('/contact') !== -1) {
      var act = form.getAttribute('action');
      var norm = normalizeInternalUrl(act, prefix);
      form.action = norm;
      form.setAttribute('action', norm);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.language-form .switcher-dropdown .label, .currency-form .switcher-dropdown .label');
    if (label) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var dropdown = label.closest('.switcher-dropdown');
      document.querySelectorAll('.switcher-dropdown.active').forEach(function (openDropdown) {
        if (openDropdown !== dropdown) openDropdown.classList.remove('active');
      });
      dropdown.classList.toggle('active');
      return;
    }

    var option = event.target.closest('[data-language] .language, [data-currency] .currency');
    if (!option) return;

    var form = option.closest('form');
    var inputName = option.classList.contains('language') ? 'locale_code' : 'country_code';
    var input = form && form.querySelector('[name="' + inputName + '"]');
    if (!form || !input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = option.getAttribute('data-value');
    HTMLFormElement.prototype.submit.call(form);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLocaleContext);
  } else {
    applyLocaleContext();
  }
  document.addEventListener('shopify:section:load', applyLocaleContext);
})();
